export const V1 = '2014-02-11';
export const V2 = '2016-10-25';
export const V3 = '2017-03-29';
export const V4 = '2017-08-01';
export const V5 = '2018-02-08';
export const LATEST_VERSION = V5;
export const VERSION_HEADER = 'Shippo-API-Version';
export const OVERRIDE_ADDRESS_HEADER = 'Shippo-Override-Addresses';
export const OVERRIDE_ADDRESS_VERSION = 'V2';
